theme.shoppingControls = (function() {
    var _shoppingControls = {};
    _shoppingControls.$quantity = $('#buy-now-button__wrapper');

    _shoppingControls.getCartItemObject  = function(targetEl) {
        var $control = $(targetEl).closest('[data-quantity-shopping-container]');
        var productId = $control.attr('data-quantity-shopping-container');
        var $qtyInput = $control.find('[data-quantity-input]');
        var $qtyProxy = $control.find('[data-quantity-text]');
        var qty = parseInt($qtyInput.val());
        var stock = parseInt($qtyInput.attr('data-stock'));

        return {
            $control: $control,
            id: productId,
            qty: qty,
            stock: stock,
            $qtyInput: $qtyInput,
            $qtyProxy: $qtyProxy
        }
    }

    _shoppingControls.registerControls = function(){
        _shoppingControls.$quantity.on('click', '[data-quick-shopping-control="sub"]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newQty = cartItem.qty - 1 > 0 ? cartItem.qty - 1 : 0;

            cartItem.$qtyInput.val(newQty);
            cartItem.$qtyProxy.html(newQty);

            $(window).trigger('dataLayer-add-update-qnty', newQty);
        });

        _shoppingControls.$quantity.on('click', '[data-quick-shopping-control="add"]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newQty = cartItem.qty + 1 <= cartItem.stock ? cartItem.qty + 1 : cartItem.qty;

            cartItem.$qtyInput.val(newQty);
            cartItem.$qtyProxy.html(newQty);

            $(window).trigger('dataLayer-add-update-qnty', newQty);
        });
    };

    _shoppingControls.init = function() {
        if(!_shoppingControls.$quantity.length) {
            console.warn('Cart Error');
            return;
        } else {
            _shoppingControls.registerControls();
        }
    };

    return _shoppingControls;
})();

$(document).on("ready", function() {
    if ( $('.item__controls-wrapper').length ) {
        theme.shoppingControls.init();
    }

    var $toggleColorSelector = $('.color_selected');
    var $colorSelector = $('.fake-color_selector');
    var $colorOption = $(".fake-color_selector .color_option");
    var $colorSelectorChevron = $(".color-selector .chevron");
    var $drawerCartButton = $('.js-drawer-open-button-right');
    $($toggleColorSelector, $colorOption).on("mouseup", function() {
        $colorSelector.toggleClass("hidden_slide");
        $colorSelectorChevron.toggleClass("active");
    });
    $($colorSelector).on("mouseleave", function(){
        $colorSelector.addClass("hidden_slide");
        $colorSelectorChevron.removeClass("active");
    });

    $drawerCartButton.on('click', function(){
        if(!CSS.supports('overflow', 'clip')) {
            window.scroll(0, 0);
        }
    })

    const description = document.querySelector('.product-single__descriptions__container');
    const readMore = document.querySelector('.product-single-read-more');

    if (description && readMore) {
        readMore.addEventListener('click', () => {
            if (description.classList.contains('open')) {
                description.classList.remove('open');
            } else {
                description.classList.add('open');
                description.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }
});
